import { PURCHASE_QUANTITY_MAX } from '../constants'

const slidecart = {
  init: () => {
    const eventListeners = new Set()

    window.CartAddedProduct=''

    const createMessageEl = () => {
      const el = document.createElement('p')
      el.innerText = 'Max quantity of 15 reached'
      el.classList.add('slidecarthq__item-warning-message')
      return el
    }

    const showWarningMessage = (itemEl) => {
      // Confirm message element does not already exist
      if (itemEl.querySelector('.slidecarthq__item-warning-message')) return
      const containerEl = itemEl.querySelector('.main')
      containerEl.appendChild(createMessageEl())
    }

    const hideWarningMessage = (itemEl) => {
      const el = itemEl.querySelector('.slidecarthq__item-warning-message')
      if (el) el.remove()
    }

    const addListeners = () => {
      // Reference elements
      const itemEls = document.querySelectorAll('.slidecarthq .item')

      itemEls.forEach((itemEl) => {
        // Reference elements
        const inputEl = itemEl.querySelector('.quantity-selector > input')
        const decreaseButtonEl = itemEl.querySelector('.quantity-selector > button:nth-child(1)')
        const increaseButtonEl = itemEl.querySelector('.quantity-selector > button:nth-child(3)')
        // Event listener handlers
        const handleIncreaseClick = (e) => {
          if (Number(inputEl.value) >= PURCHASE_QUANTITY_MAX) {
            e.stopPropagation()
            showWarningMessage(itemEl)
          }
        }
        const handleDecreaseClick = (e) => {
          hideWarningMessage(itemEl)
        }
        const handleInput = (e) => {
          if (Number(inputEl.value) > PURCHASE_QUANTITY_MAX) {
            inputEl.value = `${PURCHASE_QUANTITY_MAX}`
            showWarningMessage(itemEl)
          } else {
            hideWarningMessage(itemEl)
          }
        }
        // Add and store event listeners
        inputEl.addEventListener('input', handleInput)
        eventListeners.add({ el: inputEl, type: 'input', cb: handleInput })
        decreaseButtonEl.addEventListener('click', handleDecreaseClick)
        eventListeners.add({ el: decreaseButtonEl, type: 'click', cb: handleDecreaseClick })
        increaseButtonEl.addEventListener('click', handleIncreaseClick)
        eventListeners.add({ el: increaseButtonEl, type: 'click', cb: handleIncreaseClick })
      })
    }

    // Toggle showing or hiding upsell title text
    const toggleUpsellTitle = ({ subtotal }) => {
      const FREE_SHIPPING_THRESHOLD = window.theme.settings.cartFreeShippingThreshold
      const FREE_SHIPPING_CLASSNAME = 'shippingIsFree'
      const parentEl = document.querySelector('#slidecarthq')
      if (!parentEl || !FREE_SHIPPING_THRESHOLD || !subtotal) return
      subtotal >= FREE_SHIPPING_THRESHOLD
        ? parentEl.classList.add(FREE_SHIPPING_CLASSNAME)
        : parentEl.classList.remove(FREE_SHIPPING_CLASSNAME)
    }
    const updateCartCount = (count) => {
      document.querySelectorAll('.header-cart__count').forEach((el) => {
        el.innerHTML = count;
      })
    }
    // Fires once the cart has loaded
    window.SLIDECART_LOADED = function(cart) {
      addListeners()
      // Fires whenever slide cart has updated
      window.SLIDECART_UPDATED = function(cart) {
        // Remove all event listeners
        eventListeners.forEach((listener) =>
          listener.el.removeEventListener(listener.type, listener.cb)
        )
        eventListeners.clear()
        // Add all event listeners
        addListeners()
        // Handles the Upsell title state
        toggleUpsellTitle({ subtotal: cart.items_subtotal_price })
        updateCartCount(cart.item_count);
        /**
         * Pinterest tag conversions
         */
        if(window.CartAddedProduct != '') {
          var item = null;
          for (const i in cart.items) {
            if ( cart.items[i].id == window.CartAddedProduct.id) {
            item=  cart.items[i];
            }
          }

          if(item != null){
            pintrk('track', 'AddToCart', {
                value: (item.final_price * window.CartAddedProduct.quantity / 100),
                order_quantity: window.CartAddedProduct.quantity,
               currency: 'USD',
              });
          }
        }
        window.CartAddedProduct='';
        /**
         * End pinterest tag conversions
         */
      }
    }
    /**
     * Pinterest tag conversions
     */
    window.CartAddedProduct='';
    window.SLIDECART_ADD_TO_CART = function({ id, quantity }) {
      window.CartAddedProduct = {
        'id': id,
        'quantity': quantity
      }
    }
    window.SLIDECART_UPSELL_ADD = function(id) {
      window.CartAddedProduct = {
        'id': id,
        'quantity': 1
      }
    }
    /**
     * End pinterest tag conversions
     */
  }
}

export default slidecart